<template>
    <TabPanel
        v-bind="$attrs"
        :header="label"
    >
        <template v-if="icon" #header>
            <e-icon :icon="icon" class="e-tab-item-icon" />
            <span>{{ label }}</span>
        </template>
        <slot />
    </TabPanel>
</template>

<script>
/**
 * ETabItem - Abstraction wrapper around PrimeVue's TabPanel
 *
 * Usage:
 *   <e-tabs>
 *     <e-tab-item label="Overview">
 *       Overview content here
 *     </e-tab-item>
 *     <e-tab-item label="Details">
 *       Details content here
 *     </e-tab-item>
 *   </e-tabs>
 *
 *   <e-tabs>
 *     <e-tab-item label="Profile" icon="user">
 *       Profile content
 *     </e-tab-item>
 *     <e-tab-item label="Settings" icon="settings">
 *       Settings content
 *     </e-tab-item>
 *   </e-tabs>
 *
 *   <e-tabs>
 *     <e-tab-item label="Active" value="active">
 *       Active items
 *     </e-tab-item>
 *     <e-tab-item label="Archived" value="archived">
 *       Archived items
 *     </e-tab-item>
 *   </e-tabs>
 *
 * Props (work in both modes):
 *   - label: String - Tab label text (required)
 *   - icon: String - Icon name (optional)
 *   - value: String - Tab identifier value (optional)
 *
 * All Buefy b-tab-item props, events, and slots are supported in Buefy mode.
 * PrimeVue TabPanel props are supported in PrimeVue mode.
 */
export default {
    name: 'ETabItem',
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: undefined,
        },
        icon: {
            type: String,
            default: undefined,
        },
        value: {
            type: String,
            default: undefined,
        },
    },
};
</script>

<style lang="scss">
/* Icon spacing in tab headers */
.e-tab-item-icon {
    margin-right: 0.5rem;
}
</style>
